export const CONFIRMATION_DIALOG__CANCEL_WIRE = 'CONFIRMATION_DIALOG__CANCEL_WIRE';
